<template>
  <v-app>
    <core-toolbar v-if="user.loggedIn"/>

    <core-drawer v-if="user.loggedIn"/>

    <core-view/>
  </v-app>
</template>

<script>

import {
  mapGetters
} from 'vuex'

export default {
  data: () => ({
  }),
  computed: {
    ...mapGetters({
      user: 'user'
    })
  }
}
</script>

<style lang="scss">
@import '@/styles/index.scss';

</style>
